"use client";
//? Library Imports ------------------------------------------------------------>
import Link from "next/link";
import { Col, Image, Row, Typography } from "antd";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useState } from "react";
import "./BannerSection.scss";
import VideoPlayer from "@/components/VideoBanner/LazyVideoPlayer";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function BannerSection({ data, userAgent }) {
  const [imageLoaded, setImageLoaded] = useState({});
  const { isDesktop } = userAgent;
  const onImageLoad = (index) => {
    setImageLoaded((prev) => ({ ...prev, [index]: true }));
  };

  const Text = Typography;
  return (
    <>
      {data?.section_type === "layout_3" && (
        <Row
          className="Banner BannerSection"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {data?.main_title && (
            <Col span={24} className="sectionHeadingContainer">
              <Text
                className={
                  !isDesktop
                    ? "sectionHeadingMobileBold textCenter"
                    : "sectionHeadingBold textLeft"
                }
              >
                {data?.main_title}
              </Text>
            </Col>
          )}
          {data?.banner?.map((banner, index) => (
            <Col
              key={index}
              className="banner-item"
              style={{ flex: "0 0 49%" }}
            >
              <Link href={banner?.link ?? "#"}>
                <LazyLoadImage
                  src={banner?.img}
                  alt={banner?.img}
                  width="100%"
                  height="auto"
                  className="banner-image"
                />
              </Link>
            </Col>
          ))}
        </Row>
      )}

      {data?.section_type === "layout_2" && (
        <Row justify="center" align="middle" className="Banner BannerSection">
          {data?.main_title && (
            <Col span={24} className="sectionHeadingContainer">
              <Text
                className={
                  !isDesktop
                    ? "sectionHeadingMobileBold textCenter"
                    : "sectionHeadingBold textLeft"
                }
              >
                {data?.main_title}
              </Text>
            </Col>
          )}

          <Col span={24} className="flexCenter width100">
            {data?.banner?.map((banner, index) => {
              const [imageSrc, setImageSrc] = useState(
                banner?.img +
                  `${isDesktop ? "%3Fwidth%3D1300" : "%3Fwidth%3D720"}`
              );

              const handleImageError = () => {
                setImageSrc(banner?.img);
              };

              return (
                <div key={index}>
                  {banner?.video ? (
                    <VideoPlayer videoURL={banner?.video} />
                  ) : (
                    <Link href={banner?.link ?? "#"} className="width100">
                      <Image
                        width="100%"
                        height="auto"
                        preview={false}
                        onError={handleImageError}
                        src={imageSrc}
                        alt={
                          banner?.banner_alt_text
                            ? banner?.banner_alt_text
                            : banner?.img.split("/").pop()
                        }
                        className="desktop_banner width100"
                      />
                    </Link>
                  )}
                </div>
              );
            })}
          </Col>
        </Row>
      )}
      {data?.section_type === "layout_1" && !isDesktop && (
        <Row className="inline-banner">
          <Col span={24} className="sectionHeadingContainer">
            <Text
              className={
                !isDesktop
                  ? "sectionHeadingMobileBold textLeft"
                  : "sectionHeadingBold textLeft"
              }
            >
              {data?.main_title}
            </Text>
          </Col>
          {data.banner?.slice(0, 2).map((banner, index) => (
            <Col
              key={index}
              style={{ width: index === 0 ? "59%" : "40%" }}
              className="banner-item"
            >
              <Link href={banner?.link ?? "#"}>
                <LazyLoadImage
                  src={banner.img}
                  alt={banner.banner_alt_text}
                  width="100%"
                  height="auto"
                  className="banner-image"
                />
              </Link>
            </Col>
          ))}
        </Row>
      )}
      {data?.section_type === "layout_1" && isDesktop && (
        <Row
          justify="center"
          align="middle"
          className="Banner BannerSection BannerCollageSection"
          gutter={[16, 16]}
        >
          {data?.main_title && (
            <Col span={24} className="sectionHeadingContainer">
              <Text
                className={
                  !isDesktop
                    ? "sectionHeadingMobileBold textCenter"
                    : "sectionHeadingBold textLeft"
                }
              >
                {data?.main_title}
              </Text>
            </Col>
          )}
          <Col span={12} className="full-height-col">
            <Link href={data?.banner[0]?.link ?? "#"}>
              <LazyLoadImage
                alt={data.banner[0]?.banner_alt_text}
                effect="blur"
                src={data.banner[0]?.img}
                className="full-height-image"
              />
            </Link>
          </Col>
          <Col span={12} className="nested-col">
            <Row className="full-height-row" gutter={[13, 13]}>
              <Col span={24} className="half-height-col">
                <Link href={data?.banner[1]?.link ?? "#"}>
                  <LazyLoadImage
                    alt={data.banner[1]?.banner_alt_text}
                    effect="blur"
                    src={data.banner[1]?.img}
                    className="half-height-image"
                  />
                </Link>
              </Col>
              <Col span={12} className="quarter-height-col">
                <Link href={data?.banner[2]?.link ?? "#"}>
                  <LazyLoadImage
                    alt={data.banner[2]?.banner_alt_text}
                    effect="blur"
                    src={data.banner[2]?.img}
                    className="quarter-height-image"
                  />
                </Link>
              </Col>
              <Col span={12} className="quarter-height-col">
                <Link href={data?.banner[3]?.link ?? "#"}>
                  <LazyLoadImage
                    alt={data.banner[3]?.banner_alt_text}
                    effect="blur"
                    src={data.banner[3]?.img}
                    className="quarter-height-image"
                  />
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
}
